<template>
	<div v-if="context.organisationseinheiten">
		<template v-if="nestingLevel <= 1">
			<nk-accordion
				v-for="(
					organisationseinheit, organisationseinheitIndex
				) in context.organisationseinheiten"
				:key="organisationseinheitIndex"
				:title="organisationseinheit.name"
				:variant="nestingLevel > 0 ? 'solid' : 'default'"
				:title-size="nestingLevel > 0 ? 'lg' : 'md'"
				:open="openAccordion(organisationseinheitIndex)"
			>
				<nk-list variant="table">
					<nk-list-item
						v-for="(
							mitarbeiter, mitarbeiterIndex
						) in organisationseinheit.kontaktpersonen"
						:key="`mitarbeiter-${mitarbeiterIndex}`"
					>
						<nk-row align-items="center" gutter="2" vertical-gutter="1">
							<nk-col md="auto">
								<nk-link
									block
									:link="`${
										context.taggingpfadMitarbeiter.slice(-1) !== '/'
											? context.taggingpfadMitarbeiter + '/'
											: context.taggingpfadMitarbeiter
									}${
										$slugify(mitarbeiter.vorname + '-' + mitarbeiter.nachname) +
										'-id_' +
										mitarbeiter.id
									}`"
								>
									<nk-title tag="h3" size="base" no-margin>
										{{ mitarbeiter.vorname }}
										{{ mitarbeiter.nachname }}
									</nk-title>
								</nk-link>
							</nk-col>
							<nk-col md="shrink">
								<nk-list variant="horizontal">
									<nk-list-item
										v-if="
											mitarbeiter.kommunikationsmoeglichkeiten &&
											mitarbeiter.kommunikationsmoeglichkeiten.find(
												kontaktArt => kontaktArt.kanal === 'EMAIL',
											)
										"
									>
										<nk-link
											:link="
												'mailto:' +
												mitarbeiter.kommunikationsmoeglichkeiten.find(
													kontaktArt => kontaktArt.kanal === 'EMAIL',
												).kennung
											"
										>
											<nk-icon icon="mail" />
											E-Mail schreiben
										</nk-link>
									</nk-list-item>
									<nk-list-item
										v-if="
											mitarbeiter.kommunikationsmoeglichkeiten &&
											mitarbeiter.kommunikationsmoeglichkeiten.find(
												kontaktArt => kontaktArt.kanal === 'MOBILTELEFON',
											)
										"
									>
										<nk-link
											:link="
												'tel:' +
												mitarbeiter.kommunikationsmoeglichkeiten.find(
													kontaktArt => kontaktArt.kanal === 'MOBILTELEFON',
												).kennung
											"
										>
											<nk-icon icon="phone" />
											{{
												mitarbeiter.kommunikationsmoeglichkeiten.find(
													kontaktArt => kontaktArt.kanal === 'MOBILTELEFON',
												).kennung
											}}
										</nk-link>
									</nk-list-item>
									<nk-list-item
										v-if="
											mitarbeiter.kommunikationsmoeglichkeiten &&
											mitarbeiter.kommunikationsmoeglichkeiten.find(
												kontaktArt => kontaktArt.kanal === 'TELEFON',
											)
										"
									>
										<nk-link
											:link="
												'tel:' +
												mitarbeiter.kommunikationsmoeglichkeiten.find(
													kontaktArt => kontaktArt.kanal === 'TELEFON',
												).kennung
											"
										>
											<nk-icon icon="phone" />
											{{
												mitarbeiter.kommunikationsmoeglichkeiten.find(
													kontaktArt => kontaktArt.kanal === 'TELEFON',
												).kennung
											}}
										</nk-link>
									</nk-list-item>
								</nk-list>
							</nk-col>
						</nk-row>
					</nk-list-item>
				</nk-list>
				<nk-wrapper
					v-if="
						(organisationseinheit.untergeordneteOrganisationseinheiten &&
							organisationseinheit.untergeordneteOrganisationseinheiten
								.length) ||
						(organisationseinheit.untergeordneteOEs &&
							organisationseinheit.untergeordneteOEs.length)
					"
					spacing="sm"
				>
					<nk-template-service-bw-organisationseinheiten-minimal
						:nesting-level="nestingLevel + 1"
						:options="options"
						:context="{
							taggingpfad: context.taggingpfad,
							taggingpfadMitarbeiter: context.taggingpfadMitarbeiter,
							organisationseinheiten:
								organisationseinheit.untergeordneteOEs ||
								organisationseinheit.untergeordneteOrganisationseinheiten,
						}"
					/>
				</nk-wrapper>
			</nk-accordion>
		</template>
		<template v-else>
			<div
				v-for="(
					organisationseinheit, organisationseinheitIndex
				) in context.organisationseinheiten"
				:key="organisationseinheitIndex"
			>
				<nk-box variant="transparent">
					<nk-title size="lg">
						<nk-link
							:link="`${
								context.taggingpfad.slice(-1) !== '/'
									? context.taggingpfad + '/'
									: context.taggingpfad
							}${
								$slugify(organisationseinheit.name) +
								'-id_' +
								organisationseinheit.id
							}`"
						>
							{{ organisationseinheit.name }}
						</nk-link>
					</nk-title>
					<nk-list variant="table">
						<nk-list-item
							v-for="(
								mitarbeiter, mitarbeiterIndex
							) in organisationseinheit.kontaktpersonen"
							:key="`mitarbeiter-${mitarbeiterIndex}`"
						>
							<nk-row align-items="center" gutter="2" vertical-gutter="1">
								<nk-col md="auto">
									<nk-link
										block
										:link="`${
											context.taggingpfadMitarbeiter.slice(-1) !== '/'
												? context.taggingpfadMitarbeiter + '/'
												: context.taggingpfadMitarbeiter
										}${
											$slugify(
												mitarbeiter.vorname + '-' + mitarbeiter.nachname,
											) +
											'-id_' +
											mitarbeiter.id
										}`"
									>
										<nk-title tag="h3" size="base" no-margin>
											{{ mitarbeiter.vorname }}
											{{ mitarbeiter.nachname }}
										</nk-title>
									</nk-link>
								</nk-col>
								<nk-col md="shrink">
									<nk-list variant="horizontal">
										<nk-list-item
											v-if="
												mitarbeiter.kommunikationsmoeglichkeiten &&
												mitarbeiter.kommunikationsmoeglichkeiten.find(
													kontaktArt => kontaktArt.kanal === 'EMAIL',
												)
											"
										>
											<nk-link
												:link="
													'mailto:' +
													mitarbeiter.kommunikationsmoeglichkeiten.find(
														kontaktArt => kontaktArt.kanal === 'EMAIL',
													).kennung
												"
											>
												<nk-icon icon="mail" />
												E-Mail schreiben
											</nk-link>
										</nk-list-item>
										<nk-list-item
											v-if="
												mitarbeiter.kommunikationsmoeglichkeiten &&
												mitarbeiter.kommunikationsmoeglichkeiten.find(
													kontaktArt => kontaktArt.kanal === 'MOBILTELEFON',
												)
											"
										>
											<nk-link
												:link="
													'tel:' +
													mitarbeiter.kommunikationsmoeglichkeiten.find(
														kontaktArt => kontaktArt.kanal === 'MOBILTELEFON',
													).kennung
												"
											>
												<nk-icon icon="phone" />
												{{
													mitarbeiter.kommunikationsmoeglichkeiten.find(
														kontaktArt => kontaktArt.kanal === 'MOBILTELEFON',
													).kennung
												}}
											</nk-link>
										</nk-list-item>
										<nk-list-item
											v-if="
												mitarbeiter.kommunikationsmoeglichkeiten &&
												mitarbeiter.kommunikationsmoeglichkeiten.find(
													kontaktArt => kontaktArt.kanal === 'TELEFON',
												)
											"
										>
											<nk-link
												:link="
													'tel:' +
													mitarbeiter.kommunikationsmoeglichkeiten.find(
														kontaktArt => kontaktArt.kanal === 'TELEFON',
													).kennung
												"
											>
												<nk-icon icon="phone" />
												{{
													mitarbeiter.kommunikationsmoeglichkeiten.find(
														kontaktArt => kontaktArt.kanal === 'TELEFON',
													).kennung
												}}
											</nk-link>
										</nk-list-item>
									</nk-list>
								</nk-col>
							</nk-row>
						</nk-list-item>
					</nk-list>
					<nk-wrapper
						v-if="
							(organisationseinheit.untergeordneteOrganisationseinheiten &&
								organisationseinheit.untergeordneteOrganisationseinheiten
									.length) ||
							(organisationseinheit.untergeordneteOEs &&
								organisationseinheit.untergeordneteOEs.length)
						"
						spacing="md"
					>
						<nk-template-service-bw-organisationseinheiten
							:nesting-level="nestingLevel + 1"
							:options="options"
							:context="{
								taggingpfad: context.taggingpfad,
								taggingpfadMitarbeiter: context.taggingpfadMitarbeiter,
								organisationseinheiten:
									organisationseinheit.untergeordneteOEs ||
									organisationseinheit.untergeordneteOrganisationseinheiten,
							}"
						/>
					</nk-wrapper>
				</nk-box>
			</div>
		</template>
	</div>
</template>

<script>
import TemplatesDefault from '../../mixins/templates-default';

/**
 * @prop {string} context.titel
 * @prop {array} context.organisationseinheiten
 * @prop {string} context.taggingpfad
 * @prop {string} context.taggingpfadMitarbeiter
 */
export default {
	name: 'NkTemplateServiceBwOrganisationseinheitenMinimal',

	mixins: [TemplatesDefault],

	props: {
		nestingLevel: {
			type: Number,
			required: false,
			default: 0,
		},
	},

	methods: {
		openAccordion(index) {
			if (this.options && typeof this.options.openAccordion !== 'undefined') {
				if (typeof this.options.openAccordion === 'boolean') {
					return this.options.openAccordion;
				}

				if (Number.isInteger(this.options.openAccordion)) {
					return this.options.openAccordion === index;
				}
			}
			return this.context.length === 1;
		},
	},
};
</script>
